import React from 'react'
import Conversation from './Conversation';
import Messages from './Messages';

const Chat = () => {
    return (
        <div className="bg-white min-h-screen">
            <div className="flex bg-white">             
                <div className="flex-grow h-screen p-4">
                        <Messages/>
                </div>
            </div>
        </div>
    )
}

export default Chat
